// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"189":"fundDetail","335":"deposit","483":"betRecord","533":"withdraw","773":"gamePanel","790":"transferOut","979":"transferIn"}[chunkId] + "." + {"189":"dc318294","335":"b9eb695f","483":"dc318294","533":"effce516","773":"5946d55f","790":"177caa6d","979":"177caa6d"}[chunkId] + ".css";
};